export type FeatureModuleRow = {
  category: string;
  module: string;
  summary: string;
};

export const featureModuleRows: FeatureModuleRow[] = [
  {
    "category": "HRM",
    "module": "Smart Attendance System",
    "summary": "Absensi via lokasi/GPS, WiFi kantor, shift, WFH/WFA, visit, lembur, keterlambatan, dan approval."
  },
  {
    "category": "HRM",
    "module": "Payroll Management",
    "summary": "Otomatisasi gaji, PPh21, tunjangan/potongan, rekap, slip gaji PDF/Excel, dan export payroll bank."
  },
  {
    "category": "HRM",
    "module": "Company Internal Management",
    "summary": "Manajemen karyawan, jabatan, departemen, shift, hari libur, pengumuman, dan permission."
  },
  {
    "category": "HRM",
    "module": "Holiday & Leave",
    "summary": "Cuti/izin, alokasi, approval berlapis, lampiran, histori, dan laporan."
  },
  {
    "category": "HRM",
    "module": "360 Feedback",
    "summary": "Untuk membantu perusahaan melihat performa karyawan secara lebih menyeluruh dalam satu periode penilaian."
  },
  {
    "category": "HRM",
    "module": "Kolabo Canteen",
    "summary": "Membantu proses request dan claim makanan karyawan jadi lebih rapi, cepat, dan minim antrean."
  },
  {
    "category": "HRM",
    "module": "Reimbursement, Overtime & Visit",
    "summary": "Pengajuan lembur, biaya perjalanan, visit/field work, approval, dan rekap periodik."
  },
  {
    "category": "Recruitment",
    "module": "Kolabo E-Recruitment",
    "summary": "Job portal, kandidat, pipeline/stage, interview, offer, sampai onboarding jadi akun karyawan."
  },
  {
    "category": "Accounting",
    "module": "Kolabo Accounting",
    "summary": "Transaksi, jurnal, buku besar, laporan keuangan, faktur, hutang/piutang, pajak, budgeting, aset."
  },
  {
    "category": "Collaboration",
    "module": "Personal / Team Chat",
    "summary": "Chat private & grup, file, gambar, voice note, dan komunikasi internal yang rapi."
  },
  {
    "category": "Project",
    "module": "Project & Task Management / Kanban",
    "summary": "Task, checklist, komentar, attachment, monitoring progres, dan kanban board."
  },
  {
    "category": "CRM",
    "module": "Client & Leads Management",
    "summary": "Database klien & prospek, pipeline deal, catatan interaksi, dan reporting."
  },
  {
    "category": "Asset",
    "module": "Asset Management",
    "summary": "Data aset, pemakaian, QR code, histori, dan penyusutan aset (depresiasi) bila diperlukan."
  },
  {
    "category": "Tools",
    "module": "Kolabo Cloud",
    "summary": "Penyimpanan file terintegrasi aplikasi, pengaturan akses, upload/download, dan manajemen dokumen."
  },
  {
    "category": "Tools",
    "module": "Kolabo Meet",
    "summary": "Meeting online lintas device, bisa invite user eksternal (client) dengan mudah."
  },
  {
    "category": "AI",
    "module": "Kolabo AI - Meeting Recap",
    "summary": "Ringkasan meeting, keputusan, dan action items otomatis dari rekaman."
  },
  {
    "category": "Device",
    "module": "Kolabo Terminal",
    "summary": "Absensi via device/NFC/ID Card untuk perusahaan besar, tetap sinkron dengan ekosistem Kolabo."
  },
  {
    "category": "Security",
    "module": "Private & Secure",
    "summary": "Server premium/private, isolasi data, backup harian, dan keamanan modern."
  },
  {
    "category": "Support",
    "module": "Dedicated Support 24/7",
    "summary": "Support via WhatsApp group dedicated, respon cepat sesuai SLA."
  },
  {
    "category": "Project",
    "module": "Timesheet (Timer & Activity Log)",
    "summary": "Timer real-time start/stop/pause, log aktivitas transparan, bukti & lampiran, terhubung ke project/service, laporan & export Excel, terintegrasi Task Checklist (Use Timer)."
  },
  {
    "category": "HRM",
    "module": "KPI V2.0 (Template, Generate & Report)",
    "summary": "Template KPI per user/department/jabatan, generate massal, import Excel, bobot & formula, alur draft→ajukan→approve/reject, laporan bulanan/tahunan + grafik & ranking."
  },
  {
    "category": "HRM",
    "module": "Penalty Point & Potongan Otomatis",
    "summary": "Aturan pelanggaran (telat/pulang cepat/leave tertentu), tarik data jadi log, bisa disisipkan ke payroll sebagai potongan, rekap bisa export Excel."
  },
  {
    "category": "Security",
    "module": "View Data Permission",
    "summary": "Batasi role tertentu melihat data role lain (attendance, overtime, payroll, dan pengajuan lainnya) supaya akses data lebih aman."
  },
  {
    "category": "HRM",
    "module": "Employee Attachment Center",
    "summary": "Simpan dokumen karyawan (SP, kontrak, surat jabatan, dll) lengkap dengan judul, rapi di detail karyawan."
  },
  {
    "category": "HRM",
    "module": "Employee Contract Improvement",
    "summary": "Kontrak karyawan mendukung import dan multi-periode untuk memudahkan cek riwayat."
  },
  {
    "category": "Project",
    "module": "Client Public Report Link",
    "summary": "Link publik untuk klien pantau progres proyek; bisa pakai password & tanggal kedaluwarsa, rotate token, dan export PDF."
  },
  {
    "category": "HRM",
    "module": "Multi Attendance Location",
    "summary": "Satu karyawan bisa punya beberapa lokasi absensi (branch) untuk check in/out, tidak hanya branch utama."
  },
  {
    "category": "HRM",
    "module": "Request Attendance (Backdate)",
    "summary": "Karyawan bisa ajukan presensi backdate; setelah disetujui, data kehadiran dibuat sesuai tanggal/jam yang disepakati."
  },
  {
    "category": "HRM",
    "module": "Koperasi (Tabungan & Pinjaman)",
    "summary": "Nominal tabungan bulanan otomatis jadi potongan payroll; ajukan pinjaman & tarik tabungan via aplikasi (dengan approval) lengkap dengan riwayat."
  },
  {
    "category": "Payroll",
    "module": "Payroll Custom (THR / Pesangon / Kompensasi)",
    "summary": "Slip terpisah untuk THR/pesangon/kompensasi, komponen lebih fleksibel, cocok untuk kebutuhan payroll khusus."
  },
  {
    "category": "Payroll",
    "module": "Export Payroll Bank (BCA)",
    "summary": "Ekspor payroll mendukung format Bank BCA untuk proses transfer gaji yang lebih cepat dan rapi."
  },
  {
    "category": "HRM",
    "module": "Attendance Simple Export",
    "summary": "Ekspor ringkas: total hadir/absen, late minutes, early times, dan total overtime (jam)."
  },
  {
    "category": "HRM",
    "module": "Visit Plan / Visit Route (Geofence)",
    "summary": "Atur visit wajib sesuai titik/route yang di-assign (radius meter), bisa mode ON/OFF, dan ada periode aktif per user."
  },
  {
    "category": "Project",
    "module": "Kanban Board",
    "summary": "Tampilan board untuk memantau progres task, termasuk board per client dan opsi kembali ke tampilan list."
  },
  {
    "category": "Tools",
    "module": "Kolabo Form (Form Dinamis + Approval)",
    "summary": "Buat form sesuai kebutuhan, approval bertahap, user bisa pilih approver, notifikasi, field rumus/total, dan export PDF yang rapi."
  },
  {
    "category": "Tools",
    "module": "Meeting Scheduler (Google Calendar)",
    "summary": "Buat jadwal meeting tim dari dashboard dan sinkron ke Google Calendar."
  },
  {
    "category": "Tools",
    "module": "Popup Banner & Content Management",
    "summary": "Tampilkan banner/pengumuman ke seluruh user, dan kelola konten Rule & TnC dengan dukungan upload file."
  },
  {
    "category": "LMS",
    "module": "Learning Management System (LMS)",
    "summary": "Kelas & materi pembelajaran, kurikulum, quiz/ujian, tugas, sertifikat, progress tracking, dan laporan per user/department."
  },
  {
    "category": "LMS",
    "module": "Training & Onboarding Program",
    "summary": "Program onboarding karyawan baru, jalur belajar per role, checklist onboarding, dan validasi kelulusan."
  },
  {
    "category": "POS",
    "module": "Kolabo POS (Point of Sale)",
    "summary": "Kasir cepat, barcode/QR, multi outlet, multi payment, diskon/promo, struk, dan sinkron laporan penjualan."
  },
  {
    "category": "POS",
    "module": "Kasir dan Transaksi",
    "summary": "POS cepat dengan pencarian produk, scan barcode kamera, charge & kembalian, multi payment, catatan transaksi, struk thermal, kasbon/belum bayar, retur penjualan, histori transaksi, tambah customer saat transaksi, open register, dan kontrol kas per shift."
  },
  {
    "category": "POS",
    "module": "Produk dan Katalog",
    "summary": "Kelola nama/deskripsi produk, SKU, barcode, brand, kategori, harga beli/jual, komisi penjual, loyalty point per produk, tipe produk, outlet tersedia, unit/model, rak/shelf, gambar produk, produk jasa/non-stok, sampai bulk upload produk."
  },
  {
    "category": "POS",
    "module": "Varian, Batch, dan Stok",
    "summary": "Dukung varian ukuran/warna/model, SKU & barcode varian, identitas batch, expired tracking, FIFO, stok masuk/keluar, stock opname, pergerakan stok, notifikasi minimum stock, stok per batch/gudang, penyesuaian stok, audit histori stok, dan laporan produk expired."
  },
  {
    "category": "POS",
    "module": "Gudang dan Multi Outlet",
    "summary": "Atur gudang, cabang/outlet, transfer produk antar outlet, stok per gudang, multi cabang, switch branch, warehouse product list, kontrol owner/manajemen, laporan terpusat, stok outlet utama & outlet lain, aktivasi cabang, dan kontrol lokasi operasional."
  },
  {
    "category": "POS",
    "module": "Pembelian dan Pemasok",
    "summary": "Catat supplier, invoice supplier, penerimaan barang, pembelian due, retur pembelian, pembatalan tercatat, histori pembelian, due collection pemasok, pencarian supplier, status pembayaran pembelian, cetak invoice pembelian, dan laporan pembelian dari aplikasi maupun dashboard."
  },
  {
    "category": "POS",
    "module": "Customer, Loyalty, dan CRM Ringan",
    "summary": "Tambah customer cepat, histori transaksi customer, loyalty point, redeem point, saldo point, pelanggan tetap, nomor kontak, catatan customer, daftar due customer, pembuatan customer via aplikasi/dashboard, histori point, poin di struk, dan kontak customer yang lebih rapi."
  },
  {
    "category": "POS",
    "module": "Resep, Material, dan Produksi",
    "summary": "Kelola resep/BOM, material/bahan baku, penggunaan material, produksi, kontrol biaya bahan, keterkaitan ke produk & stok, laporan material, bulk upload recipe/material, audit penggunaan bahan, estimasi resep, dan pelacakan material usage."
  },
  {
    "category": "POS",
    "module": "Keuangan, Register, dan Laporan",
    "summary": "Open register, cash flow operasional, income & expense, charge report, komisi sales, top selling, ringkasan harian/mingguan/bulanan, custom range report, profit & loss, tax report, stock report, stock movement, due report customer/supplier, sales & purchase report, return report, transaction history, dan material usage report."
  },
  {
    "category": "POS",
    "module": "Harga, Barcode, Label, dan Pencetakan",
    "summary": "Cetak barcode produk, label harga, barcode scan kamera, thermal print, struk rapi, invoice pembelian/penjualan, export A4/PDF/CSV/Excel, custom print, pengaturan printer, auto reconnect printer thermal, printer Bluetooth dari aplikasi, dan distribusi APK."
  },
  {
    "category": "POS",
    "module": "Pengaturan, Permission, dan Pajak",
    "summary": "Role user & permission, payment type yang bisa disetting, field pembayaran tambahan, bahasa & currency, tax/VAT setting, general business settings, invoice settings, settings hub, akses per role untuk modul terbaru, user archive aman, kategori income/expense, pengaturan dashboard, sales, dan cetak invoice."
  },
  {
    "category": "POS",
    "module": "Aplikasi, Offline Mode, SaaS, dan Superadmin",
    "summary": "Offline mode dengan sinkron transaksi saat koneksi kembali, Flutter app + dashboard web, trial demo 14 hari, lead trial untuk sales & superadmin, superadmin control, backup database harian, cloud ready, siap Play Store, pendaftaran via landing page/aplikasi, email verifikasi trial, akun demo otomatis, WhatsApp follow up, dan kontrol tenant/bisnis."
  },
  {
    "category": "Inventory",
    "module": "Inventory & Warehouse Management",
    "summary": "Multi gudang, stok masuk/keluar, stock opname, minimum stock, batch/lot (opsional), dan mutasi antar gudang."
  },
  {
    "category": "Procurement",
    "module": "Purchase & Vendor Management",
    "summary": "Supplier/vendor, purchase order, penerimaan barang, bill, retur pembelian, dan histori harga beli."
  },
  {
    "category": "Logistics",
    "module": "Delivery Order / Surat Jalan",
    "summary": "Buat surat jalan, driver & kendaraan, rute/rit, status pengiriman, POD (bukti serah terima), dan export laporan."
  },
  {
    "category": "Logistics",
    "module": "Shipment Cost & UJP Management",
    "summary": "Kelola biaya pengiriman per zona/wilayah, cost breakdown, rekap per rit, dan integrasi ke invoice/petty cash."
  },
  {
    "category": "Finance",
    "module": "Petty Cash & Cashflow Control",
    "summary": "Kas kecil per gudang/cabang, pengajuan & approval, bukti transaksi, dan rekap laporan kas harian/bulanan."
  },
  {
    "category": "Finance",
    "module": "Budgeting (RAB/RAP) & Realization",
    "summary": "Susun anggaran per proyek/divisi, pembatasan budget, realisasi biaya, dan laporan selisih (variance)."
  },
  {
    "category": "HRM",
    "module": "Approval Berlapis (Supervisor → HR → Finance)",
    "summary": "Alur persetujuan bisa bertahap sesuai struktur perusahaan, lengkap dengan catatan approve/reject dan riwayatnya."
  },
  {
    "category": "HRM",
    "module": "Shift & Office Time Bulanan",
    "summary": "Atur jam kerja bisa beda per tanggal, per orang, dan bisa import template shift bulanan."
  },
  {
    "category": "HRM",
    "module": "Attendance with Photo",
    "summary": "Opsional check-in pakai foto untuk perusahaan yang butuh bukti visual saat absensi."
  },
  {
    "category": "HRM",
    "module": "Potongan Telat (Interval / Fix) + Batas Harian",
    "summary": "Aturan denda keterlambatan bisa per interval (mis. tiap 15 menit) atau nominal tetap, dengan limit maksimal per hari."
  },
  {
    "category": "HRM",
    "module": "Pengumuman, Banner & Notifikasi",
    "summary": "Sampaikan info penting ke seluruh user/role tertentu, ada histori, dan bisa muncul sebagai popup di aplikasi."
  },
  {
    "category": "HRM",
    "module": "Dashboard HR (Ringkasan Karyawan)",
    "summary": "Lihat ringkasan data karyawan: gender, umur, kontrak, skill/sertifikasi, dan statistik sederhana untuk evaluasi cepat."
  },
  {
    "category": "HRM",
    "module": "Integrasi Fingerprint / Mesin Absensi",
    "summary": "Tarik data dari mesin absensi (fingerprint/face) ke Kolabo untuk jadi data kehadiran, bisa disesuaikan mapping jam & user."
  },
  {
    "category": "Device",
    "module": "NFC / ID Card Attendance",
    "summary": "Absensi dengan kartu ID/NFC untuk kebutuhan onsite, cocok untuk pabrik/gudang/operasional."
  },
  {
    "category": "HRM",
    "module": "Klaim Reimburse dengan Bukti Lengkap",
    "summary": "Upload banyak bukti (nota/foto) dan catatan, approval lebih rapi, rekap per periode lebih enak dicek."
  },
  {
    "category": "Payroll",
    "module": "Metode Payroll (Gross / Gross Up / Nett)",
    "summary": "Metode hitung gaji & PPh21 bisa disesuaikan dengan kebijakan perusahaan."
  },
  {
    "category": "Payroll",
    "module": "Perhitungan PPH 21 Peraturan Terbaru",
    "summary": "Perhitungan PPH 21 mengikuti peraturan terbaru dengan skema yang dapat disesuaikan kebijakan perusahaan."
  },
  {
    "category": "Payroll",
    "module": "Slip Gaji",
    "summary": "Generate slip gaji karyawan otomatis per periode dengan rincian komponen pendapatan dan potongan."
  },
  {
    "category": "Payroll",
    "module": "Slip Gaji Detail (Termasuk Overtime)",
    "summary": "Slip gaji menampilkan rincian lembur (mulai, selesai, status approval) dan komponen gaji lebih jelas."
  },
  {
    "category": "Payroll",
    "module": "Payroll Fleksibel (Harian / Mingguan / Range Tanggal)",
    "summary": "Bisa buat payroll di luar cut-off normal, cocok untuk harian, mingguan, atau periode custom."
  },
  {
    "category": "Payroll",
    "module": "Kasbon / Cash Advance (Auto Potong Payroll)",
    "summary": "Karyawan bisa ajukan kasbon, ada approval & status cicilan; saat payroll dibuat bisa otomatis jadi pengurangan."
  },
  {
    "category": "HRM",
    "module": "Overtime Otomatis Saat Checkout",
    "summary": "Kalau checkout melebihi jam kerja, sistem bisa munculkan opsi lembur otomatis (sesuai pengaturan kantor)."
  },
  {
    "category": "HRM",
    "module": "Self Shift Change (Opsional)",
    "summary": "Karyawan bisa ganti shift/jam kerja sendiri dari aplikasi (kalau diaktifkan), tetap ada kontrol dan histori."
  },
  {
    "category": "Tools",
    "module": "E-Sign & Document Workflow",
    "summary": "Approval dokumen berlapis, e-sign (opsional), versi dokumen, audit trail, dan arsip terstruktur."
  },
  {
    "category": "Analytics",
    "module": "Executive Dashboard & KPI Analytics",
    "summary": "Dashboard ringkas lintas modul (HR, Sales, Finance, Ops), grafik tren, ranking, dan insight performa."
  },
  {
    "category": "Integration",
    "module": "API & Webhook Integration",
    "summary": "Integrasi ke aplikasi eksternal (ERP/marketplace/IoT), webhook event (attendance, invoice, payment), dan sinkron data."
  },
  {
    "category": "Mobile",
    "module": "Mobile Apps (HRM / POS / Field Ops)",
    "summary": "Aplikasi mobile untuk absensi, approval, task, chat, POS, dan operasional lapangan dengan notifikasi real-time."
  },
  {
    "category": "Accounting",
    "module": "Produk, Jasa & Harga Jual",
    "summary": "Kelola daftar produk/jasa, satuan, harga jual/beli, dan relasi ke persediaan atau biaya."
  },
  {
    "category": "Accounting",
    "module": "Diskon, Biaya Lain & Pembulatan",
    "summary": "Atur diskon, ongkir/biaya lain, dan pembulatan di invoice/bill supaya totalnya rapi sesuai kebutuhan."
  },
  {
    "category": "Accounting",
    "module": "Pembayaran Parsial & Termin",
    "summary": "Cocok untuk proyek/kontrak: invoice bisa dibayar bertahap, ada sisa tagihan, dan jatuh tempo tetap kepantau."
  },
  {
    "category": "Accounting",
    "module": "Multi Cabang / Unit (Laporan per Cabang)",
    "summary": "Pisahkan transaksi per cabang/unit, lalu tarik laporan per cabang atau konsolidasi sesuai kebutuhan."
  },
  {
    "category": "AI",
    "module": "AI Chat Assistant",
    "summary": "Asisten chat di dashboard untuk membantu pengguna memahami menu dan cara pakai Kolabo dengan penjelasan yang lebih sederhana dan langkah-langkah yang mudah diikuti."
  },
  {
    "category": "Integration",
    "module": "Accounting Sync",
    "summary": "Membantu mengirim data penting dari HRM ke Accounting seperti client, project, reimburse, payroll, kasbon, tabungan & pinjaman, serta expense agar data lebih rapi dan tidak perlu input berulang."
  },
  {
    "category": "Payroll",
    "module": "Pengaturan Potongan Ketidakhadiran",
    "summary": "Perusahaan sekarang bisa mengatur potongan absen dan unpaid leave dengan nominal yang lebih fleksibel sesuai kebijakan masing-masing."
  },
  {
    "category": "Project",
    "module": "Project View Permission",
    "summary": "Akses melihat project bisa dibatasi hanya untuk user tertentu, sehingga detail project, task, dan checklist lebih aman dan tidak terbuka ke semua orang."
  },
  {
    "category": "HRM",
    "module": "Overtime Multi Record per Hari",
    "summary": "Lembur sekarang bisa dicatat lebih dari satu kali dalam satu hari, jadi kalau ada lembur siang lalu lanjut malam, semuanya tetap tersimpan dengan rapi."
  },
  {
    "category": "Accounting",
    "module": "Multi Approval & Digital Sign",
    "summary": "Dokumen Accounting sekarang bisa melewati beberapa tahap persetujuan dan mendukung tanda tangan digital per pengguna agar proses persetujuan lebih tertib dan jelas."
  },
  {
    "category": "Accounting",
    "module": "Smart Audit",
    "summary": "Membantu melihat kondisi keuangan bisnis dalam satu halaman, menampilkan temuan penting, saran tindak lanjut, dan area yang perlu segera dicek lebih dulu."
  },
  {
    "category": "Accounting",
    "module": "Depresiasi Aset",
    "summary": "Memudahkan perusahaan memantau nilai aset dari waktu ke waktu, termasuk nilai awal, total penyusutan, dan nilai buku aset."
  },
  {
    "category": "Accounting",
    "module": "Modal & Prive",
    "summary": "Mencatat setoran modal, penambahan modal, dan pengambilan modal dengan lebih rapi agar pergerakan modal usaha lebih mudah dipantau."
  },
  {
    "category": "Accounting",
    "module": "Rekonsiliasi Keuangan",
    "summary": "Membantu mengecek kecocokan data keuangan dan menemukan selisih dengan lebih cepat agar laporan lebih rapi dan mudah ditindaklanjuti."
  },
  {
    "category": "Inventory",
    "module": "Laporan Stok Penjualan & Pembelian",
    "summary": "Mempermudah memantau pergerakan barang masuk dan keluar berdasarkan aktivitas penjualan dan pembelian."
  },
  {
    "category": "Accounting",
    "module": "Laporan Keuangan per Project",
    "summary": "Data dan laporan kini bisa difilter per project sehingga biaya, pendapatan, dan hasil per project lebih mudah dipantau."
  },
  {
    "category": "Finance",
    "module": "Import RAB & RAP",
    "summary": "RAB dan RAP sekarang mendukung import data massal supaya input lebih cepat dan lebih praktis."
  },
  {
    "category": "Accounting",
    "module": "Sub Invoice",
    "summary": "Invoice sekarang mendukung invoice turunan agar pengelolaan tagihan bertahap menjadi lebih rapi."
  },
  {
    "category": "Accounting",
    "module": "Return Barang Sebagian",
    "summary": "Pengembalian barang kini bisa dilakukan sebagian saja tanpa harus semua, dan jumlah barang maupun tagihan akan ikut menyesuaikan."
  },
  {
    "category": "CRM",
    "module": "Pipeline Deal (Tahapan Penjualan)",
    "summary": "Atur tahapan deal dari prospek sampai closing, lengkap dengan nilai deal, probabilitas, dan target closing date."
  },
  {
    "category": "CRM",
    "module": "Aktivitas & Riwayat Follow Up",
    "summary": "Catat telepon/meeting/chat, next follow up, dan histori komunikasi biar tim sales nggak kehilangan konteks."
  },
  {
    "category": "CRM",
    "module": "Task untuk Sales (To-Do & Reminder)",
    "summary": "Buat tugas follow up per lead/client, assign ke PIC, ada due date, dan bisa dipantau progresnya."
  },
  {
    "category": "CRM",
    "module": "Kontak & Perusahaan (Multi Contact)",
    "summary": "Satu client bisa punya banyak kontak (purchasing, owner, finance), lengkap dengan nomor, email, dan jabatan."
  },
  {
    "category": "CRM",
    "module": "Tag, Sumber Lead & Kategori",
    "summary": "Kelompokkan prospek berdasarkan sumber (iklan, referensi, event), kategori bisnis, atau tag supaya rapi dan gampang difilter."
  },
  {
    "category": "CRM",
    "module": "Assign PIC & Kolaborasi Tim",
    "summary": "Set PIC utama/pendamping untuk tiap akun, jadi pembagian area dan tanggung jawab lebih jelas."
  },
  {
    "category": "CRM",
    "module": "Catatan Internal & Lampiran",
    "summary": "Simpan note internal, upload file (penawaran, kontrak, foto lokasi, dll) biar semua dokumen nempel di akun client."
  },
  {
    "category": "CRM",
    "module": "Link ke Project / Task",
    "summary": "Kalau deal sudah jalan, bisa sambungkan client ke project dan task supaya eksekusi tim lebih terarah."
  },
  {
    "category": "CRM",
    "module": "Quotation / Penawaran (Opsional)",
    "summary": "Buat penawaran harga untuk klien, simpan versi penawaran, dan pantau statusnya sebelum jadi invoice."
  },
  {
    "category": "CRM",
    "module": "Reporting Sales (Per PIC / Per Periode)",
    "summary": "Lihat performa sales: jumlah lead masuk, deal aktif, deal menang/kalah, dan nilai closing per periode."
  },
  {
    "category": "CRM",
    "module": "Lost Reason & Evaluasi",
    "summary": "Kalau deal gagal, bisa isi alasan (harga, kompetitor, timing, dll) supaya evaluasi sales lebih gampang."
  },
  {
    "category": "Banking",
    "module": "Banking (Bank Account, Mutasi & Rekonsiliasi)",
    "summary": "Kelola rekening bank, import/rekam mutasi, pencocokan transaksi (reconciliation), saldo real-time, dan histori lengkap per rekening."
  },
  {
    "category": "Sales",
    "module": "Sales (Order, Invoice, Delivery, Payment)",
    "summary": "Proses penjualan end-to-end: sales order, invoice, pembayaran (parsial/termin), status piutang, dan integrasi stok & jurnal."
  },
  {
    "category": "Income",
    "module": "Income Management (Pendapatan Non-Sales)",
    "summary": "Catat pendapatan lain-lain (bunga, sewa, service fee), kategori akun, lampiran bukti, dan otomatis masuk jurnal & laporan."
  },
  {
    "category": "Expense",
    "module": "Expense Management (Biaya Operasional)",
    "summary": "Catat biaya harian/bulanan, kategori akun & cost center, approval opsional, lampiran, dan rekap per periode/divisi."
  },
  {
    "category": "Double Entry",
    "module": "Double Entry (Jurnal Umum & Chart of Account)",
    "summary": "Input jurnal debit/kredit, COA lengkap, posting otomatis dari modul lain, audit trail, dan kontrol balancing sebelum posting."
  },
  {
    "category": "Budget Planner",
    "module": "Budget Planner (Anggaran Tahunan/Bulanan)",
    "summary": "Susun budget per akun/divisi/cabang, limit & notifikasi, perbandingan budget vs actual, serta laporan selisih."
  },
  {
    "category": "Contract",
    "module": "Contract Management",
    "summary": "Kelola kontrak klien/vendor: nilai kontrak, termin, masa berlaku, dokumen & lampiran, reminder jatuh tempo, dan tracking realisasi."
  },
  {
    "category": "Goal",
    "module": "Goal & Target Tracking",
    "summary": "Target penjualan/pendapatan/produktivitas per tim/PIC, progres otomatis dari transaksi, milestone, dan dashboard ringkas."
  },
  {
    "category": "Commission",
    "module": "Commission Management",
    "summary": "Skema komisi sales (flat/bertingkat), per produk/deal/termin, kalkulasi otomatis, approval, dan export rekap komisi."
  },
  {
    "category": "Constant",
    "module": "Master Data (Constant)",
    "summary": "Pusat master data: kategori, satuan, pajak, metode pembayaran, status, template nomor dokumen, dan konfigurasi lintas modul."
  },
  {
    "category": "Report",
    "module": "Financial & Operational Report Center",
    "summary": "Pusat laporan: profit & loss, neraca, arus kas, aging hutang/piutang, stok, payroll, sales, serta export PDF/Excel."
  },
  {
    "category": "CRM",
    "module": "CRM Document Center",
    "summary": "Dokumen terpusat untuk deal/client: penawaran, kontrak, PO klien, lampiran meeting, versioning, dan akses berbasis role."
  },
  {
    "category": "CRM",
    "module": "CRM Insights Dashboard",
    "summary": "Insight penjualan: funnel conversion, win rate, sumber lead terbaik, aktivitas harian, performa PIC, dan prediksi pipeline (opsional)."
  },
  {
    "category": "CRM",
    "module": "CRM Products (Catalog for Deals)",
    "summary": "Katalog produk/jasa untuk dipakai di deal/quotation: price list, paket, diskon, dan histori penggunaan per klien."
  },
  {
    "category": "Collaboration",
    "module": "Team Meeting & Minutes",
    "summary": "Jadwal meeting tim, notulen, keputusan & action items, assignment ke task, lampiran, dan histori rapat per project/divisi."
  },
  {
    "category": "Project",
    "module": "Service Management",
    "summary": "Kelola layanan/servis: ticket/permintaan, SLA, status & prioritas, assignment PIC, checklist, dan laporan performa layanan."
  },
  {
    "category": "Tools",
    "module": "Export Center",
    "summary": "Ekspor data lintas modul (HR, Finance, Project, CRM) dengan filter periode/cabang/role, format PDF/Excel, dan template siap pakai."
  },
  {
    "category": "Tools",
    "module": "Notice & Announcement Center",
    "summary": "Kelola notice/pengumuman terstruktur: audience per role, jadwal tayang, popup/in-app, arsip, dan tracking pembacaan (opsional)."
  },
  {
    "category": "Billing",
    "module": "Billing & Subscription Management",
    "summary": "Kelola paket, lisensi user, add-on modul, invoice langganan, riwayat pembayaran, dan kontrol akses berdasarkan status billing."
  },
  {
    "category": "Settings",
    "module": "Settings & Integrations",
    "summary": "Pengaturan aplikasi: role/permission, approval flow, template nomor dokumen, notifikasi, integrasi API, dan konfigurasi modul."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Force",
    "summary": "Dorong follow up cepat via WhatsApp untuk menjaga respons dan konversi sales tetap tinggi."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Notification",
    "summary": "Notifikasi otomatis WhatsApp untuk update status deal, reminder, dan aktivitas penting tim."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Blast",
    "summary": "Kirim pesan massal tersegmentasi ke prospek/klien dengan monitoring status pengiriman."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Auto Reply",
    "summary": "Balas otomatis pesan masuk berdasarkan template, jam kerja, atau trigger tertentu."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Integration",
    "summary": "Integrasi WhatsApp langsung ke alur CRM untuk pencatatan interaksi dan follow up."
  },
  {
    "category": "CRM",
    "module": "WhatsApp Multi Session",
    "summary": "Kelola beberapa sesi WhatsApp sekaligus untuk kebutuhan multi tim atau multi brand."
  },
  {
    "category": "CRM",
    "module": "Quotation dan Invoice",
    "summary": "Buat penawaran dan invoice langsung dari CRM agar proses deal ke penagihan lebih cepat."
  },
  {
    "category": "CRM",
    "module": "Documents Management",
    "summary": "Pusat pengelolaan dokumen klien/deal dengan lampiran, versi, dan akses berbasis role."
  },
  {
    "category": "CRM",
    "module": "Pipeline Management",
    "summary": "Atur alur pipeline penjualan dari lead hingga closing dengan visibilitas progres yang jelas."
  },
  {
    "category": "CRM",
    "module": "Stage Management",
    "summary": "Kustomisasi tahapan pipeline sesuai proses bisnis dan kontrol perpindahan stage."
  },
  {
    "category": "CRM",
    "module": "Web Form",
    "summary": "Tangkap lead dari formulir website dan otomatis masuk ke CRM beserta sumbernya."
  },
  {
    "category": "CRM",
    "module": "Terintegrasi dengan Accounting",
    "summary": "Sinkron data transaksi CRM ke Accounting untuk penagihan dan pelaporan keuangan."
  },
  {
    "category": "HRM",
    "module": "Terintegrasi dengan Accounting, CRM dan Project Management",
    "summary": "Data HRM terhubung lintas modul agar proses operasional, finansial, dan proyek lebih selaras."
  },
  {
    "category": "HRM",
    "module": "Pusat Integrasi Lintas Platform",
    "summary": "Hub integrasi HRM untuk menghubungkan workflow internal dengan sistem eksternal perusahaan."
  },
  {
    "category": "Accounting",
    "module": "SPK",
    "summary": "Kelola Surat Perintah Kerja (SPK) terstruktur dan terhubung ke proses biaya serta penagihan."
  },
  {
    "category": "Accounting",
    "module": "RAB dan RAP",
    "summary": "Perencanaan RAB/RAP dengan kontrol realisasi anggaran agar biaya proyek tetap terjaga."
  },
  {
    "category": "Accounting",
    "module": "Terintegrasi dengan CRM",
    "summary": "Hubungkan data deal, quotation, dan invoice dari CRM ke proses akuntansi."
  },
  {
    "category": "Accounting",
    "module": "Multi Company",
    "summary": "Kelola pembukuan beberapa perusahaan dalam satu platform dengan kontrol akses terpisah."
  },
  {
    "category": "Accounting",
    "module": "Multi Cabang",
    "summary": "Kelola transaksi dan laporan keuangan per cabang dengan konsolidasi terpusat."
  }
];
